import React from 'react';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { FormattedMessage } from '../../../util/reactIntl';
import { pathByRouteName } from '../../../util/routes';
import { apiBaseUrl } from '../../../util/api';
import { xenforoRegisterUrl } from '../../../util/xenforoUrls';
import { ExternalLink, SocialLoginButton } from '../../../components';
import css from './SocialLoginButtons.module.css';

const KEY_CODE_ENTER = 13;

const SocialLoginButtons = props => {
  const routeConfiguration = useRouteConfiguration();
  const { from, userType, onOpenTermsOfService, onOpenPrivacyPolicy } = props;

  const getDataForSSORoutes = () => {
    const baseUrl = apiBaseUrl();
    const defaultReturn = pathByRouteName('LandingPage', routeConfiguration);
    const defaultConfirm = pathByRouteName('ConfirmPage', routeConfiguration);
    const queryParams = new URLSearchParams({
      ...(defaultReturn ? { defaultReturn } : {}),
      ...(defaultConfirm ? { defaultConfirm } : {}),
      ...(from ? { from } : {}),
      ...(userType ? { userType } : {}),
    });
    return { baseUrl, queryParams: queryParams.toString() };
  };

  const authWithXenforo = () => {
    const { baseUrl, queryParams } = getDataForSSORoutes();
    window.location.href = `${baseUrl}/api/auth/xenforo?${queryParams}`;
  };

  const handleClickLink = callback => e => {
    e.preventDefault();
    callback?.();
  };

  const handleKeyUpLink = callback => e => {
    if (e.keyCode === KEY_CODE_ENTER) {
      callback?.();
    }
  };

  const termsLink = (
    <span
      className={css.tosLink}
      onClick={handleClickLink(onOpenTermsOfService)}
      role="button"
      tabIndex={0}
      onKeyUp={handleKeyUpLink(onOpenTermsOfService)}
    >
      <FormattedMessage id="SocialLoginButtons.termsLinkText" />
    </span>
  );

  const privacyLink = (
    <span
      className={css.tosLink}
      onClick={handleClickLink(onOpenPrivacyPolicy)}
      role="button"
      tabIndex={0}
      onKeyUp={handleKeyUpLink(onOpenPrivacyPolicy)}
    >
      <FormattedMessage id="SocialLoginButtons.privacyLinkText" />
    </span>
  );

  return (
    <div className={css.root}>
      <div className={css.actions}>
        <SocialLoginButton rootClassName={css.primaryButton} onClick={authWithXenforo}>
          <FormattedMessage id="AuthenticationPage.loginWithR2R" />
        </SocialLoginButton>
        <ExternalLink className={css.secondaryButton} href={xenforoRegisterUrl()}>
          <FormattedMessage id="AuthenticationPage.createAccount" />
        </ExternalLink>
        <p className={css.caption}>
          <FormattedMessage id="AuthenticationPage.createAccountCaption" />
        </p>
      </div>

      {(onOpenTermsOfService || onOpenPrivacyPolicy) && (
        <p className={css.tosNote}>
          <FormattedMessage
            id="SocialLoginButtons.bySigningInYouAccept"
            values={{ termsLink, privacyLink }}
          />
        </p>
      )}
    </div>
  );
};

export default SocialLoginButtons;
